import React, {Component, useEffect, useRef, useState, useLayoutEffect, useReducer} from 'react'
import { Rnd } from "react-rnd";
import {MeasureImg} from "../uiUtils/Helpers";
import {shallowReducer} from "../lib/Utils";

//? Does logo have to be placed completely inside Ad
// i.e. would quark support it hanging over the edge
// Could have user drag logo "on to" the ad
// Could do that any way - drag & release - then position and size

// Note: ImagePlacer now also displays the overlay when not dragging

const getInitialSizePos = ({backgroundSize, overlayRealSize, defaultAreaRatio})=> {

    const scale = Math.sqrt(
        (backgroundSize.width * backgroundSize.height)
        / (overlayRealSize.width * overlayRealSize.height * defaultAreaRatio)
    );

    const sizePosition = {
        width: overlayRealSize.width * scale,
        height: overlayRealSize.height * scale
    };
    sizePosition.x = backgroundSize.width - sizePosition.width;
    sizePosition.y = backgroundSize.height - sizePosition.height;

    console.log('Initial: ',sizePosition);
    return sizePosition;
}

const getPercentFromPixelSizePos = ({backgroundSize, pixelSizePos})=> {
    const sp = {
        x: pixelSizePos.x / backgroundSize.width,
        y: pixelSizePos.y / backgroundSize.height,
        width: pixelSizePos.width / backgroundSize.width,
        height: pixelSizePos.height / backgroundSize.height
    };
    sp.area = sp.height * sp.width;

    console.log('Percent: ',sp);
    return sp;
}


const getPixelsFromPercentCoordinates = ({percentCoordinates, backgroundSize, overlayRealSize})=>{
    const {top, left, bottom, right} = percentCoordinates;

    // All this jigery pokery ensures the logo stays in bounds if the logo or ad change dimension
    // and that we keep the logo proportions

    const derivedRatio = 1 / ( (right - left) * (bottom - top) ) ;
    let derivedScale = Math.sqrt(
        (backgroundSize.width * backgroundSize.height)
        / (overlayRealSize.width * overlayRealSize.height * derivedRatio)
    );

    if (overlayRealSize.width * derivedScale > backgroundSize.width) {
        derivedScale = backgroundSize.width / overlayRealSize.width ;
    }
    if (overlayRealSize.height * derivedScale > backgroundSize.height) {
        derivedScale = backgroundSize.height / overlayRealSize.height ;
    }
    const sizePosition = {
        width: overlayRealSize.width * derivedScale,
        height: overlayRealSize.height * derivedScale
    };

    sizePosition.x = backgroundSize.width * left;
    sizePosition.y = backgroundSize.height * top;

    if (sizePosition.x + sizePosition.width > backgroundSize.width) {
        sizePosition.x = backgroundSize.width - sizePosition.width;
    }
    if (sizePosition.y + sizePosition.height > backgroundSize.height) {
        sizePosition.y = backgroundSize.height - sizePosition.height;
    }

    console.log('Pixels: ',sizePosition);
    return sizePosition;
}



export default function ImagePlacer(
    {
        backgroundUrl= '',  //? support component
        backgroundColor= 'limegreen',
        area= 512*512,  //total pixels
        defaultAreaRatio = 16,
        outlineWidth= 2,
        imageColor= 'red',
        overlayUrl= '', //? support component
        mode, setMode,
        percentCoordinates ,  // from current overlay
        onChange= console.log,
        isGrayscale = false,
        ...props
    }
)
{
    const dragRef = useRef(null);
    // Image pixel sizes
    const [backgroundRealSize, setBackgroundRealSize] = useState({});
    const [overlayRealSize, setOverlayRealSize] = useState({});
    // display sizes & position
    const [backgroundSize, setBackgroundSize] = useState({});
    const [overlaySizePos, setOverlaySizePos] = useReducer(shallowReducer,{});  //pixels current overlay
    const [dragSizePos, setDragSizePos] = useReducer(shallowReducer,{});  //pixels dragging

    useEffect(()=>{
        const scale = Math.sqrt(area / (backgroundRealSize.width * backgroundRealSize.height) );
        setBackgroundSize({
            width: backgroundRealSize.width * scale,
            height: backgroundRealSize.height * scale
        });
    },[backgroundRealSize, area]);

    useLayoutEffect(()=>{
        const sizePosition = percentCoordinates && percentCoordinates.right
            ? getPixelsFromPercentCoordinates({percentCoordinates, overlayRealSize, backgroundSize})
            : getInitialSizePos({backgroundSize, overlayRealSize, defaultAreaRatio});
        setOverlaySizePos(sizePosition);
    },[percentCoordinates, overlayRealSize,backgroundSize]);

    useLayoutEffect(()=>{
        dragRef.current.reset(overlaySizePos);
        console.log('Reset: ', overlaySizePos);
    },[overlaySizePos, mode]);


    useEffect(()=>{
        const sp = getPercentFromPixelSizePos({backgroundSize, pixelSizePos: dragSizePos});

        if (!isNaN(sp.area) ){
            onChange(sp);
        }
    }, [dragSizePos,backgroundSize]);

    const startPositioning = () => {
        if (overlayUrl) setMode('position')
    }

    const backgroundStyle = {
        width: backgroundSize.width || 100,
        height: backgroundSize.height || 'auto',
        outlineStyle: 'solid',
        outlineColor: backgroundColor ,
        outlineWidth: mode === 'position' ? outlineWidth : 0,
        boxSizing: 'border-box'
    };
    const overlayStyle = {
        width: '100%',
        height: '100%',
        outlineStyle: 'dashed',
        outlineColor: imageColor,
        outlineWidth: mode === 'position' ? outlineWidth : 0,
        boxSizing: 'border-box'
    };
    if (isGrayscale) {
        backgroundStyle.filter = overlayStyle.filter = 'grayscale(100%)';
    }

    const scrollWrapperStyle = {
        overflowX: 'scroll',
        overflowY: 'hidden',
        whiteSpace: 'nowrap',
        padding: outlineWidth
    };
    const outerFrameStyle = {
        //margin:props.outlineWidth,
        display: 'inline-block',
        position: 'relative',
        width: backgroundSize.width || 100,
        height: (backgroundSize.height )|| 'auto'
    };

    return (
        <div style={scrollWrapperStyle} onClick={startPositioning}>
            <MeasureImg src={backgroundUrl} onMeasure={setBackgroundRealSize}/>
            <MeasureImg src={overlayUrl} onMeasure={setOverlayRealSize}/>
            <div style={outerFrameStyle}
            >
                <img draggable="false" src={backgroundUrl} style={backgroundStyle} alt='Spec Ad' {...props}/>
                <Draggable onChange={setDragSizePos}
                             disabled={mode !== 'position'}
                             ref={dragRef}
                             visible={(percentCoordinates && percentCoordinates.right) || mode === 'position'}
                >
                    <img draggable="false"
                         src={overlayUrl || ''}
                         style={overlayStyle}
                         alt='Logo'
                         onClick={startPositioning}
                    />
                </Draggable>
            </div>
            <div style={{height:10}}/>
        </div>
    );
}


class Draggable extends Component {
    constructor(props) {
        super(props);
    }

    // Called for either dropStop or resizeStop
    changed(sizePosition){
        if (this.props.onChange) {
            if (!('width' in sizePosition) ){
                const {offsetWidth,offsetHeight} = this.rnd.getSelfElement();
                sizePosition.width = offsetWidth;
                sizePosition.height = offsetHeight;
            }
            this.props.onChange(sizePosition);
        }
    }

    reset(sizePos){
        if (sizePos) {
            this.rnd.updateSize(sizePos);
        }
        this.rnd.updatePosition(sizePos); //todo??
    }
/*
position={{x:this.props.sizePos.x, y:this.props.sizePos.y}}
                 size={{width:this.props.sizePos.width, height:this.props.sizePos.height}}
 */

    render() {

        const dragStyle = {
            backgroundColor: this.props.disabled ? '' : 'rgba(1,1,1,0.3)',
            display: this.props.visible ? '' : 'none'
        };

        return (
            <Rnd style={dragStyle}
                 ref={c => { this.rnd = c; }}
                 lockAspectRatio={true}
                 minHeight={this.props.minHeight}
                 disableDragging={this.props.disabled}

                 bounds={'parent'}
                 onDragStop={(e, d) => {
                     this.changed({ x: d.x, y: d.y });
                 }}
                 onResizeStop={(e, direction, ref, delta, position) => {
                     this.changed({
                         width: ref.offsetWidth,
                         height: ref.offsetHeight,
                         ...position
                     });
                 }}
                 >
                 {this.props.children}
            </Rnd>
        );
    }
}
Draggable.defaultProps = {
    minHeight: 20
};